export const GOAL_COLLISION = 'g';
export const ARCADIAN_ADDED = 'a';
export const LEVEL_COMPLETE = 'l';
export const LEVEL_QUIT = 'levelQuit';
export const HEART_PICKUP = 'h';
export const CUT_ROPE = 'c';
export const START_LEVEL = 's';
export const RESTART_LEVEL = 'r';
export const START_NEXT_LEVEL = 'x';
export const ARCADIAN_HEAD_SELECTED = 'i';
export const NEAR_TOKENS_ADDED = 'n';
export const NFT_BUY = 'b';
export const MONETIZATION_PROGRESS = 'p';
export const PLAYER_DIED = 'd';
export const TOGGLE_MUSIC = 't';

export const AD_PLAYING = 'adPlaying';
export const AD_FINISHED = 'adFinished';
